export default "__VITE_ASSET__5tlCtd27__"